export default __webpack_public_path__ + "static/media/CALDERASIN.faa2f6d0.png";